import Easing from './easing';

const raf = (() => {
    const def = (cb, el) => {
        window.setTimeout(cb, 1000 / 60);
    };

    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        def;
})();

export default (a, b, options = {duration: 1000, fn: 'def'}) => {
    const startTime = performance.now();

    const step = timestamp => {
        const val = Easing[options.fn](timestamp - startTime, a, b, options.duration);

        options.onStep(val);

        if ((timestamp - startTime) < options.duration) {
            raf(step);
        } else {
            options.onFinish();
        }
    };

    raf(step);
};
